"use client";
import { ChangeEvent, useEffect, useRef, useState } from "react";
import { useUser } from "@/app/context/UserContext";
import AccordionItem from "../Elements/AccordionItem";
import { useConfig } from "@/app/context/ConfigContext";
import { TypeEnvironment } from "@/app/constants/enums";
import { iProPromptParams } from "@/app/models/interfaceProject";
import { ChevronDown, Pencil, Upload } from "lucide-react";
import { Constantes } from "@/app/constants/constantsGlobal";

const PROVIDERS = [
  { value: "google/gemini", text: "Google / Gemini" },
  { value: "azure/openai", text: "Azure / OpenAI" },
];

const MODEL_TYPES = [
  { value: "high", text: "High" },
  { value: "medium", text: "Medium" },
  { value: "basic", text: "Basic" },
  { value: "low", text: "Low" },
];

const ConfigProjectEdit: React.FC = () => {
  const { userProject, setUserProject } = useUser();
  const { queryParams} = useConfig();
  const [isEditingForm, setIsEditingForm] = useState(true);    
  useEffect(() => {  
    if(userProject.project.env == TypeEnvironment.Prod){ 
      setIsEditingForm(false);
    } 
  }, []);
  // Inicializar estados con valores de userProject
  const [formData, setFormData] = useState<iProPromptParams>({
    assistant_name: userProject?.config?.prompt_params?.assistant_name || "",
    assistant_role: userProject?.config?.prompt_params?.assistant_role || "",
    company_activity: userProject?.config?.prompt_params?.company_activity || "",
    company_name: userProject?.config?.prompt_params?.company_name || "",
    conversation_purpose: userProject?.config?.prompt_params?.conversation_purpose || "",
    welcome_message: userProject?.config?.prompt_params?.welcome_message || "",
    alias: userProject?.config?.prompt_params?.alias|| "",
  });

  const [configData, setConfigData] = useState({
    provider: userProject?.config?.config_params?.provider || "google/gemini",
    model_type: userProject?.config?.config_params?.model_type || "basic",
    temperature: userProject?.config?.config_params?.temperature || 0.0,
    k_top_retrieval: userProject?.config?.config_params?.k_top_retrieval || 0.0,
    max_token_history: userProject?.config?.config_params?.max_token_history || 0.0,
    k_top_history: userProject?.config?.config_params?.k_top_history || 0.0,
    max_minutes: userProject?.config?.config_params?.max_minutes|| 10
  });

  // provider: userProject?.config?.prompt_params?.provider || "google/gemini",
  // model_type: userProject?.config?.prompt_params?.model_type || "basic",

  // Actualizar estados cuando cambia userProject
  useEffect(() => {
    setFormData({
      assistant_name: userProject?.config?.prompt_params?.assistant_name || "",
      assistant_role: userProject?.config?.prompt_params?.assistant_role || "",
      company_activity: userProject?.config?.prompt_params?.company_activity || "",
      company_name: userProject?.config?.prompt_params?.company_name || "",
      conversation_purpose: userProject?.config?.prompt_params?.conversation_purpose || "",
      welcome_message: userProject?.config?.prompt_params?.welcome_message || "",
      alias: userProject?.config?.prompt_params?.alias || "",
    });

    setConfigData({
      provider: userProject?.config?.config_params?.provider || "google/gemini",
      model_type: userProject?.config?.config_params?.model_type || "basic",
      temperature: userProject?.config?.config_params?.temperature || 0.0,
      k_top_retrieval: userProject?.config?.config_params?.k_top_retrieval || 0.0,
      max_token_history: userProject?.config?.config_params?.max_token_history || 0.0,
      k_top_history: userProject?.config?.config_params?.k_top_history || 0.0,
      max_minutes: userProject?.config?.config_params?.max_minutes|| 10
    });
  }, [userProject?.config]);

  // Manejar cambios en los inputs
  const handleFormDataChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>) => {
    const newFormData = { ...formData, [e.target.name]: e.target.value };
    setFormData(newFormData);
    setUserProject({
      ...userProject,
      config: { ...userProject.config, prompt_params: newFormData },
    });
  };

  // Manejar cambios en los sliders
  const handleConfigChange = (name: string, value: any) => {
    const parsedValue = typeof configData[name as keyof typeof configData] === "number"
      ? parseFloat(value)
      : value;

    const newConfig = { ...configData, [name]: parsedValue };
    setConfigData(newConfig);
    setUserProject({
      ...userProject,
      config: { ...userProject.config, config_params: newConfig },
    });
  };

  const handleAliasChange = (value: string) => {
    setUserProject((prev: any) => ({
      ...prev,
      project: { ...prev.project, alias: value.trim() },
    }));
  };

  // bot icon upload
  const botIconInputRef = useRef<HTMLInputElement | null>(null);
  const [isBotIconMaxSize, setIsBotIconMaxSize] = useState(false);

  const handleBotIconChange = (e: ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    if (!file) return;
    setIsBotIconMaxSize(file.size > Constantes.MAX_IMAGE_SIZE);
    if (file.size > Constantes.MAX_IMAGE_SIZE) return;
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => {
      if (typeof reader.result === "string") {
        setUserProject((prev: any) => ({
          ...prev,
          project: { ...prev.project, icono_bot: reader.result },
        }));
      }
    };
  };

  const handleBotIconButtonClick = () => {
    botIconInputRef.current?.click();
  };

  // acordion
    const [openIndexAcordion, setOpenIndexAcordion] = useState<number | null>(null);
    const handleOpenAcordion = (index: number) => {
      setOpenIndexAcordion(openIndexAcordion === index ? null : index);
    };
    //handleOpenAcordion(0);

  return (
    <div>

        
            <form className="grid grid-cols-1 md:grid-cols-2 gap-4 px-3 py-3"> 
                <div>
                <label className="block text-sm font-medium">Nombre Asistente</label>
                  <input
                      type="text"
                      name="assistant_name"
                      placeholder="Nombre Asistente"
                      value={formData.assistant_name}
                      onChange={handleFormDataChange}
                      className="w-full p-2 border rounded focus:outline-none focus:ring-1 focus:ring-blue-700 n-fmr-input"
                      disabled={!isEditingForm}
                  />
                </div>
                <div>
                <label className="block text-sm font-medium">Alias Asistente</label>
                  <input
                      type="text"
                      name="assistant_alias"
                      placeholder="Alias Asistente"
                      value={userProject ? userProject?.project?.alias : ""}
                      onChange={(e) => handleAliasChange(e.target.value)}
                      className="w-full p-2 border rounded focus:outline-none focus:ring-1 focus:ring-blue-700 n-fmr-input"
                      //disabled={!isEditingForm}
                  />
                </div>
                <div>
                  <label className="block text-sm font-medium">Rol Asistente</label>
                  <input
                      type="text"
                      name="assistant_role"
                      placeholder="Rol Asistente"
                      value={formData.assistant_role}
                      onChange={handleFormDataChange}
                      className="w-full p-2 border rounded focus:outline-none focus:ring-1 focus:ring-blue-700 n-fmr-input"
                      disabled={!isEditingForm}
                  />
                </div>
                <div>
                  <label className="block text-sm font-medium">Nombre Compañía</label>
                  <input
                      type="text"
                      name="company_name"
                      placeholder="Nombre Compañía"
                      value={formData.company_name}
                      onChange={handleFormDataChange}
                      className="w-full p-2 border rounded focus:outline-none focus:ring-1 focus:ring-blue-700 n-fmr-input"
                      disabled={!isEditingForm}
                  />
                </div>
                <div>
                  <label className="block text-sm font-medium">Actividad Compañía</label>
                  <input
                      type="text"
                      name="company_activity"
                      placeholder="Actividad Compañía"
                      value={formData.company_activity}
                      onChange={handleFormDataChange}
                      className="w-full p-2 border rounded focus:outline-none focus:ring-1 focus:ring-blue-700 n-fmr-input"
                      disabled={!isEditingForm}
                  />
                </div>
                <div>
                  <label className="block text-sm font-medium mb-1">Foto de perfil del bot <span className="text-gray-400 font-normal">(opcional)</span></label>
                  <input
                    type="file"
                    accept="image/*"
                    className="hidden"
                    ref={botIconInputRef}
                    onChange={handleBotIconChange}
                  />
                  <div className="flex items-center gap-3">
                    <div
                      className="w-12 h-12 rounded-lg bg-cover bg-center border border-gray-300 flex-shrink-0"
                      style={{
                        backgroundImage: userProject?.project?.icono_bot
                          ? `url(${userProject.project.icono_bot})`
                          : "none",
                        backgroundColor: userProject?.project?.icono_bot ? "transparent" : "#f3f4f6",
                      }}
                    >
                      {!userProject?.project?.icono_bot && (
                        <div className="w-full h-full flex items-center justify-center text-gray-400 text-xs">Sin foto</div>
                      )}
                    </div>
                    <div className="flex flex-col gap-1">
                      <button
                        type="button"
                        onClick={handleBotIconButtonClick}
                        disabled={!isEditingForm}
                        className="flex items-center gap-1 px-3 py-1.5 border rounded text-sm bg-gray-100 hover:bg-gray-200 transition-colors disabled:opacity-50"
                      >
                        <Upload className="w-4 h-4" strokeWidth={1.5} />
                        Subir imagen
                      </button>
                      {isBotIconMaxSize && (
                        <p className="text-red-500 text-xs">Tamaño máximo: 1MB</p>
                      )}
                      {userProject?.project?.icono_bot && (
                        <button
                          type="button"
                          onClick={() => setUserProject((prev: any) => ({ ...prev, project: { ...prev.project, icono_bot: "" } }))}
                          disabled={!isEditingForm}
                          className="text-xs text-red-500 hover:underline disabled:opacity-50 text-left"
                        >
                          Quitar foto
                        </button>
                      )}
                    </div>
                  </div>
                </div>
                <div className="col-span-1 md:col-span-2">
                  <label className="block text-sm font-medium">Propósito de la Conversación</label>
                  <textarea
                      name="conversation_purpose"
                      placeholder="Propósito de la Conversación"
                      value={formData.conversation_purpose}
                      onChange={handleFormDataChange}
                      rows={3}
                      className="w-full p-2 border rounded focus:outline-none focus:ring-1 focus:ring-blue-700 n-fmr-input"
                      disabled={!isEditingForm}
                  />
                </div>
                <div className="col-span-1 md:col-span-2">
                <label className="block text-sm font-medium">Mensaje de bienvenida</label>
                <textarea
                    name="welcome_message"
                    placeholder="Mensaje de bienvenida"
                    value={formData.welcome_message}
                    onChange={handleFormDataChange}
                    rows={3}
                    className="w-full p-2 border rounded focus:outline-none focus:ring-1 focus:ring-blue-700 n-fmr-input"
                    disabled={!isEditingForm}
                />
                </div>
            </form> 
          <AccordionItem title="Configuración Avanzada" index={1} isOpen={openIndexAcordion === 1} onClick={handleOpenAcordion}>
            <div className="flex justify-center items-center w-full">
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 w-full p-6 ">
                  <div>
                    <label className="block text-sm font-medium">Proveedor</label>
                    <div className="relative">
                      <select
                        value={configData.provider}
                        name="provider"
                        onChange={(e) => handleConfigChange(e.target.name, e.target.value)}
                        disabled={!isEditingForm}
                        className="appearance-none w-full border n-fmr-input my-2 px-4 pr-10 py-2 border-gray-300 focus:outline-none focus:ring-1 focus:ring-blue-700 leading-tight"
                      >
                        {PROVIDERS.map((option) => (
                          <option key={option.value} value={option.value}>
                            {option.text}
                          </option>
                        ))}
                      </select>
                      <ChevronDown className="w-5 h-5 absolute top-1/2 right-3 -translate-y-1/2 pointer-events-none text-gray-400" />
                    </div>
                  </div>
                  <div>
                    <label className="block text-sm font-medium">Tipo de Modelo</label>
                    <div className="relative">
                      <select
                        name="model_type"
                        value={configData.model_type}
                        onChange={(e) => handleConfigChange(e.target.name, e.target.value)}
                        disabled={!isEditingForm}
                        className="appearance-none w-full border n-fmr-input my-2 px-4 pr-10 py-2 border-gray-300 focus:outline-none focus:ring-1 focus:ring-blue-700 leading-tight"
                      >
                        {MODEL_TYPES.map((option) => (
                          <option key={option.value} value={option.value}>
                            {option.text}
                          </option>
                        ))}
                      </select>
                      <ChevronDown className="w-5 h-5 absolute top-1/2 right-3 -translate-y-1/2 pointer-events-none text-gray-400" />
                    </div>
                  </div>
                {[
                  { name: "temperature", label: "Temperatura", min: 0, max: 1.0, step: 0.01 },
                  { name: "k_top_retrieval", label: "K-Top Retrieval", min: 1, max: 20, step: 1 },
                  { name: "max_token_history", label: "Max Token History", min: 0, max: 1000, step: 1 },
                  { name: "k_top_history", label: "K-Top History", min: 0, max: 100, step: 1 },
                  { name: "max_minutes", label: "Tiempo de expiración de sesión", min: 10, max: 1440, step: 10 },
                ].map(({ name, label, min, max, step }) => (
                  <div key={name} className="flex flex-col gap-2">
                    
                      <label className="block flex justify-between"> 
                        <span className="text-sm font-medium">{label}</span> 
                        <span className="text-sm font-bold">{configData[name as keyof typeof configData]} / {max}</span> 
                      </label>


                    <input
                      type="range"
                      min={min}
                      max={max}
                      step={step}
                      value={configData[name as keyof typeof configData]}
                      onChange={(e) => handleConfigChange(name, parseFloat(e.target.value))}
                      disabled={!isEditingForm}
                      className={`
                        w-full 
                      `}
                    />

                    <div className="flex justify-between text-xs text-gray-500 dark:text-gray-400">
                      <span>{min}</span>
                      <span>{max}</span>
                    </div>
                  </div>
                ))}
              </div>
            </div>

        </AccordionItem>

    </div>
  );
};

export default ConfigProjectEdit;
